<script setup>
import { onMounted, ref } from 'vue';
import Header from '@/components/Header.vue';
import Icon from '@/components/Icon.vue';
import api from '@/libs/api.js';
import { useRouter } from 'vue-router';

const data = ref({});
const showAddFeedback = ref(false);
const showDetail = ref(false);
const router = useRouter();

onMounted(() => {
    getData()  
})

const add = () => {
    router.push({name: 'feedback'});
};
const close = () => {
    showAddFeedback.value = false;
    showDetail.value = false;
};

const getData = () => {
    api.get('get-notification-user').then((res) => {
        data.value = res.data.data
        
    })
}

const detail = () => {
    showDetail.value = true;
};
const item = ref({})
const handleDetail = (val) => {
    item.value = val
    showDetail.value = true
    if(val.read_at === null){
        api.post('/notifications/'+val.id+'/read').then((res) => {
            console.log(res.message)
        })
    }

}
const back = () => {
    showDetail.value = false
    getData()
}
const format = (date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();

    return `${day}-${month}-${year} ${hours}:${minutes}`;
}
</script>

<template>
    <div class="w-full h-full overflow-auto">
        <Header text="hộp thư" :back="false">
            <div v-if="false" class="w-full flex justify-end items-center">
                <Icon name="list-check" class="w-6 h-6 fill-white" />
            </div>
        </Header>
        <div class="w-full h-full pt-14">
            <div v-if="data.length > 0" class="w-full h-auto">
                 <div @click="handleDetail(item)" v-for="(item, index) in data" :key="index" class="w-full h-auto flex justify-between items-start gap-2 px-6 py-2"
                :class="{
                    'bg-bghover' : item.read_at === null,
                    'bg-white' : item.read_at != null
                }">
                    <div class="w-10 flex justify-start items-start pt-1">
                        <Icon v-if="item.read_at === null" name="close-mail" class="w-6 h-6 fill-white p-1 bg-main rounded" />
                        <Icon v-else name="open-mail" class="w-6 h-6 fill-white p-1 bg-main rounded" />
                    </div>
                    <div class="w-full">
                        <h3 class="font-bold text-lg pb-1" v-html="item.data.data.name"></h3>
                        <p class="w-full text-justify pb-1 text-sm" v-html="item.data.data.body"></p>
                        <p class="text-gray-400 text-xs">
                            {{ format( new Date(item.created_at)) }}
                        </p>
                    </div>
                </div>
            </div>
            <div v-else class="py-4 px-6 h-full bg-white text-gray-500 text-sm">  
                <img src="@/assets/images/no-mail.png" alt="">
                <p class="text-center w-full font-bold text-lg text-gray-800">Bạn không có thông báo nào🥲</p>
                <p class="text-justify py-2">
                    Quản lý tòa nhà sx gửi thông báo cho bạn ngay khi có cấp nhật mới về hóa đơn, hợp đồng, phản ánh,
                    thông báo chung...
                </p>
                <p class="text-justify py-2">
                    Đừng quên cho phép nhận thông báo để không bị bỏ lỡ những thông tin quan trọng nhé!
                </p>
                <div class="w-full flex justify-center items-center py-8">
                    <button @click="add" type="button"
                        class="w-full font-bold text-center py-3 bg-main text-white rounded shadow">
                        Tạo phản ánh
                    </button>
                </div>
            </div>
        </div>
    </div>
     <Transition name="slide-fade">
        <div v-if="showDetail" class="fixed top-0 w-full left-0 h-full overflow-y-scroll     z-50 bg-white">
            <div class="py-4 px-4 font-semibold flex items-center justify-between bg-main text-white">
                <svg @click="back" class="mr-1.5 -ml-1.5 " xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M12.5 5L8.20711 9.29289C7.87377 9.62623 7.70711 9.79289 7.70711 10C7.70711 10.2071 7.87377 10.3738 8.20711 10.7071L12.5 15" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Chi tiết thông báo
                <div></div>
            </div>
            <div class="px-4">
                <div class="font-semibold mb-1 pt-3">{{item.data.data.name}}</div>
                <div class="flex items-center text-sm text-gray-600 border-b border-gray-300 pb-3">
                    <svg class="w-4 h-4 text-main dark:text-white mr-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                    </svg>
                    {{ format( new Date(item.created_at)) }}
                </div>
                <div class="text-sm text-gray-600 mb-1 pt-3" v-html="item.data.data.body"></div>
            </div>
        </div>
    </Transition>
</template>